import React from "react";
import { WarningCircleIcon, XIcon } from "@phosphor-icons/react";
import ModalButton from "../ModalButton";
import {
  StyledPopup,
  Content,
  HeadCard,
  IconWrap,
  Title,
  Intro,
  Footer,
} from "./styles";

type Props = {
  open: boolean;
  color: string;
  title: string;
  descriptionOne: string;
  descriptionTwo: string;
  acceptLabel: string;
  requestChangeLabel: string;
  onAccept: () => void;
  onRequestChange: () => void;
  onClose: () => void;
};

/**
 * Modal de confirmación de dirección en el paso 2 de Marca Blanca.
 */
const MarcaBlancaAddressConfirmModal: React.FC<Props> = ({
  open,
  color,
  title,
  descriptionOne,
  descriptionTwo,
  acceptLabel,
  requestChangeLabel,
  onAccept,
  onRequestChange,
  onClose,
}) => {
  return (
    <StyledPopup
      open={open}
      modal
      closeOnDocumentClick={false}
      closeOnEscape={false}
      onClose={() => undefined}
    >
      <div className="container">
        <Content>
          <HeadCard>
            <XIcon
              size={20}
              color="#999999"
              style={{ cursor: "pointer" }}
              onClick={onClose}
            />
          </HeadCard>
          
          <IconWrap>
            <WarningCircleIcon size={56} weight="regular" color="#F5C518" />
          </IconWrap>

          <Title>{title}</Title>
          <Intro>{descriptionOne}</Intro>
          <Intro>{descriptionTwo}</Intro>
        </Content>

        <Footer>
          <ModalButton color={color} secondary={false} onClick={onAccept}>
            {acceptLabel}
          </ModalButton>
          <ModalButton color={color} secondary onClick={onRequestChange}>
            {requestChangeLabel}
          </ModalButton>
        </Footer>
      </div>
    </StyledPopup>
  );
};

export default MarcaBlancaAddressConfirmModal;
